import { call } from '@advanza/api'
import LoginBox from '@trustoo/components/login/LoginBox'
import { getLogoUrls } from '@trustoo/utils/localeUtils'
import LoginError from 'components/login/LoginError'
import { getQueryRedirect } from 'components/login/redirectAfterLogin'
import { useEffect, useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

/** What `auth/get-two-factor-secret` answers. */
interface TwoFactorSecretResponse {
    /** Where to go instead, e.g. when the secret was set up before. */
    redirect?: string
    qrData?: string
}

const TwoFactorSecret = () => {
    const [qrData, setQrData] = useState('')
    const [redirect, setRedirect] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        call('auth/get-two-factor-secret').then(
            (response: TwoFactorSecretResponse) => {
                const queryRedirect = getQueryRedirect()

                if (response.redirect) {
                    setRedirect(
                        response.redirect +
                            (queryRedirect ? `?redirect=${encodeURIComponent(queryRedirect)}` : ''),
                    )
                } else if (response.qrData) {
                    setQrData(response.qrData)
                }
            },
            (response: { error?: string }) => setError(response.error ?? 'Something went wrong'),
        )
    }, [])

    if (redirect) {
        return <Navigate to={redirect} replace />
    }

    return (
        <LoginBox title="Two-factor authentication" logoUrl={getLogoUrls().default}>
            <div className="flex flex-col gap-4 pt-4">
                <h2 className="m-0 text-lg">Secret</h2>
                {qrData && (
                    <>
                        <p className="m-0">
                            Scan this QR code to get the secret in Google Authenticator (or similar
                            app like FreeOTP):
                        </p>
                        <img src={qrData} alt="QR code" className="self-center" />
                    </>
                )}
                <Link
                    className="text-[#5788ff]"
                    to={`/two-factor-one-time-code${window.location.search}`}>
                    Then go to the page to enter a one-time code
                </Link>
                {error && <LoginError message={error} />}
            </div>
        </LoginBox>
    )
}

export default TwoFactorSecret
